module.exports = __webpack_public_path__ + "static/img/designBanner4.670410f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designBanner4.gif
// module id = mQUI
// module chunks = 2